import * as React from 'react';

export const MortgageIcon = () => (
  <svg width="55" height="64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity=".6" d="M50.291 57.992H0V21.998L25.146 0 50.29 21.997v35.995z" fill="#fff" />
    <path
      d="M55 39.11c0 5.355-2.193 10.115-5.782 13.486C45.83 55.77 36.26 64 36.26 64s-9.77-8.33-13.258-11.602c-3.49-3.371-5.583-8.131-5.583-13.288 0-10.312 8.374-18.74 18.84-18.74C46.727 20.37 55 28.698 55 39.11z"
      fill="url(#mortgage_paint0_linear)"
    />
    <path
      d="M36.26 20.27C46.726 20.27 55 28.6 55 39.013l-1.638.268c0-9.504-7.552-17.108-17.107-17.108-9.554 0-17.197 7.694-17.197 17.108 0 4.707 1.91 9.052 5.095 12.13l-1.151.89c-3.49-3.372-5.583-8.132-5.583-13.288 0-10.313 8.374-18.742 18.84-18.742z"
      fill="url(#mortgage_paint1_linear)"
    />
    <path
      d="M30.476 36.996c1.945 0 3.52-1.567 3.52-3.5s-1.575-3.5-3.52-3.5c-1.944 0-3.52 1.567-3.52 3.5s1.576 3.5 3.52 3.5zM43.552 49.995c1.944 0 3.52-1.567 3.52-3.5s-1.576-3.5-3.52-3.5-3.52 1.567-3.52 3.5 1.576 3.5 3.52 3.5zM43.624 30.582L27.55 46.56l2.845 2.828L46.47 33.41l-2.845-2.828z"
      fill="#fff"
    />
    <defs>
      <linearGradient
        id="mortgage_paint0_linear"
        x1="23.574"
        y1="26"
        x2="45.747"
        y2="51.003"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".283" stopColor="#FC944F" />
        <stop offset=".719" stopColor="#FF7E00" />
      </linearGradient>
      <linearGradient
        id="mortgage_paint1_linear"
        x1="50.228"
        y1="26.75"
        x2="24.041"
        y2="53.09"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".172" stopColor="#FF7E00" />
        <stop offset=".484" stopColor="#FFE3C8" />
        <stop offset=".734" stopColor="#FF7F01" />
      </linearGradient>
    </defs>
  </svg>
);

MortgageIcon.displayName = 'MortgageIcon';
